/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userPinResetWithToken.internal

import features.userPinResetWithToken.models.PinResetWithTokenRequestModel
import kangaroorewards.appsdk.core.io.EmptyResponse
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserPinResetWithTokenRequest : NetworkRequest() {

    suspend fun resetPinWithToken(
        overrideHeaders: Map<String, String>? = null,
        pinResetWithTokenRequest: PinResetWithTokenRequestModel
    ): IOResult<EmptyResponse> {
        return safeNetworkCall {
            post<EmptyResponse, PinResetWithTokenRequestModel>(
                endpoint = UserPinResetWithTokenEndpoint,
                requestBody = pinResetWithTokenRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
